export enum SubscriptionStatus {
    Active = 'active',
    Unverified = 'unverified',
    Cancelled = 'cancelled',
    Paused = 'paused'
}